module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMzgzMzQwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDcuNDQgNDA3LjQ0Ij48cGF0aCBkPSJNMzg2LjI2IDkxLjU3TDIwMy43MiAyNzMuNSAyMS4xOCA5MS41OCAwIDExMi44bDIwMy43MiAyMDMuMDdMNDA3LjQ0IDExMi44Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/styles/collapsable/chevron.svg
// module id = ./src/styles/collapsable/chevron.svg
// module chunks = 21